export default __webpack_public_path__ + "static/media/3.810835b4.png";